import styled from "styled-components"
import { Form } from "antd"
import Button from "src/components/MyButton/Button"

const LoginPageStyled = styled.div`
    display: flex;
    min-height: 100%;
    padding: 20px 0;
    overflow-y: auto;
    flex-direction: column;
    margin: 0 auto;
    max-width: 992px;
    justify-content: center;
    align-items: center;
    .logo-login {
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 1;
        margin-bottom: 10px;
        & > div {
            margin: 20px 0;
            font-size: 24px;
            color: #fff;
            text-align: center;
        }
    }
    @media (max-width: 603px) {
        .logo-login {
            & > img {
                width: 100px;
                //height: 100px;
            }
            & > div {
                font-size: 20px;
            }
        }
    }
    
`

const BackgroundImage = styled.img`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover
`

const ThumbnailImg = styled.img`
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover
`

const BlockLogin = styled.div`
    display: flex;
    z-index: 1;
    max-width: 100%;
    background-color: rgb(255, 255, 255);
    border-radius: 20px;
    padding: 20px 16px;
    box-shadow: -9px -11px 16px 0 rgba(0, 0, 0, 0.39);
    margin: 0 10px;
    .left {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        .fade-img {
            position: relative;
            &:after {
                content:"";
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
                height: 40%;
            }
        }

        .fade-img:after {
        }
        .fade-right-image {
            width: 300px;
            height: auto;
            mask-image: linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
        }
    }
    .right {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
        padding: 0 24px;
    }
    @media (max-width: 603px) {
        .left {
            display: none;
        }
    }
`

const FormStyle = styled(Form)`
    .ant-form-item-label {
        font-size: 14px;
        padding: 0;
    }
    @media (max-width: 603px) {
        .ant-form-item {
            margin-bottom: 10px;
        }
    }
`

const TextTitle = styled.div`
    font-weight: bold;
    font-size: 20px;
    color: #282828;
    margin-bottom: 8px;
    text-align: center;
    font-style: italic;
    @media (max-width: 603px) {
        font-size: 18px;
    }
`

const ButtonStyle = styled(Button)`
    border-style: solid;
    border-width: 2px;
    border-color: rgb(25, 104, 179);
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0);
    width: 100%;
    height: 44px !important;
`

const BlockInput = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    outline: none;
    background-color: transparent;
    padding: 8px 12px;
    letter-spacing: 0.03rem;
    height: 44px;
    border: 1px solid rgb(128, 130, 133);
    .ant-input {
        border: none;
    }
    .ant-input-outlined {
        &:focus-within {
            box-shadow: none !important;
        }
        border: none;
    }
    .ant-input-status-error {
        border: none !important;
    }
`

export {
    LoginPageStyled,
    TextTitle,
    BackgroundImage,
    BlockLogin,
    FormStyle,
    ButtonStyle,
    BlockInput,
    ThumbnailImg,
}
